<template>
    <div>
        <app-data-table
            v-if="!!tableData"
            :fields="fields"
            :items="tableData.data"
            :from="tableData.from"
            :to="tableData.to"
            :current-page="tableData.current_page"
            :last-page="tableData.last_page"
            :total="tableData.total"
            :per-page="tableData.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="hit" slot-scope="{ item }">{{
                item.hit | yesno
            }}</template>
            <template slot="scratch" slot-scope="{ item }">{{
                item.scratch | yesno
            }}</template>
            <template slot="radio" slot-scope="{ item }">{{
                item.radio | yesno
            }}</template>
            <template slot="antenna" slot-scope="{ item }">{{
                item.antenna | yesno
            }}</template>
            <template slot="mirror" slot-scope="{ item }">{{
                item.mirror | yesno
            }}</template>
            <template slot="wheel" slot-scope="{ item }">{{
                item.wheel | yesno
            }}</template>
            <template slot="bezel" slot-scope="{ item }">{{
                item.bezel | yesno
            }}</template>
            <template slot="accesories" slot-scope="{ item }">{{
                item.accesories | yesno
            }}</template>
            <template v-slot:created_at="{ item }">
                {{ item.created_at | datetime }}
            </template>
            <template slot="action" slot-scope="{ item }">
                <b-btn
                    size="sm"
                    variant="primary"
                    @click="$emit('showImage', item)"
                >
                    <i class="fa fa-search-plus" aria-hidden="true"></i>
                </b-btn>
            </template>
        </app-data-table>
        <b-alert show v-else>Esperando datos...</b-alert>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: [Object, String],
            default: '',
        },
        onChangePage: {
            type: Function,
        },
    },
    data: () => ({
        fields,
    }),
}
const fields = [
    {
        key: 'vehicle.plate',
        label: 'Placa',
        orderBy: 'vehicle.plate',
    },
    {
        key: 'owner',
        label: 'Dueño',
        orderBy: 'owner',
    },
    {
        key: 'observation',
        label: 'Observacion',
        orderBy: 'vehicle_states.observation',
    },
    {
        key: 'user.name',
        label: 'Registrado por',
        orderBy: 'users.name',
    },
    {
        key: 'hit',
        label: 'Golpes',
        orderBy: 'vehicle_states.hit',
    },
    {
        key: 'scratch',
        label: 'Rayones',
        orderBy: 'vehicle_states.scratch',
    },
    {
        key: 'radio',
        label: 'Radio',
        orderBy: 'vehicle_states.radio',
    },
    {
        key: 'antenna',
        label: 'Antena',
        orderBy: 'vehicle_states.antenna',
    },
    {
        key: 'mirror',
        label: 'Espejos',
        orderBy: 'vehicle_states.mirror',
    },
    {
        key: 'wheel',
        label: 'Llantas',
        orderBy: 'vehicle_states.wheel',
    },
    {
        key: 'bezel',
        label: 'Bisel',
        orderBy: 'vehicle_states.bezel',
    },
    {
        key: 'accesories',
        label: 'Accesorios',
        orderBy: 'vehicle_states.accesories',
    },
    {
        key: 'created_at',
        label: 'Fecha de creación',
        orderBy: 'vehicle_states.created_at',
    },
    {
        key: 'action',
        label: 'acción',
    },
]
</script>
